import { GenerateEmailRequest, GenerateEmailResponse } from 'pco-product-service-internal-consumer';
import { memberZoneApi } from 'api';

export const generateEmail = async (
  partnerNumber: string,
  requestBody: GenerateEmailRequest,
): Promise<GenerateEmailResponse> => {
  return await memberZoneApi.generateEmail({
    partnerUid: partnerNumber,
    generateEmailRequest: requestBody,
  });
};
